module.exports = __webpack_public_path__ + "img/automatic-mode-active-icon.781a5a20.svg";